import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import Lightbox from 'yet-another-react-lightbox';
import { Fullscreen, Zoom } from 'yet-another-react-lightbox/plugins';
import 'yet-another-react-lightbox/styles.css';

// @ts-ignore
const { tyreImages, tyreImageUrl } = window;

interface TyreLightboxProps {
  images: string[];
  initialImageUrl: string;
}

const TyreLightbox: React.FC<TyreLightboxProps> = ({ images, initialImageUrl }) => {
  const [open, setOpen] = useState(false);
  const [currentImageUrl, setCurrentImageUrl] = useState(initialImageUrl);

  useEffect(() => {
    const handleImageChange = (event: CustomEvent) => {
      setCurrentImageUrl(event.detail.imageUrl);
    };

    // @ts-ignore
    window.addEventListener('mainImageChanged', handleImageChange);

    // @ts-ignore
    return () => window.removeEventListener('mainImageChanged', handleImageChange);
  }, []);

  const currentIndex = images.findIndex((img) => img === currentImageUrl);
  const slides = images.map((img) => ({ src: img }));

  return (
    <>
      <img id="main-image" src={currentImageUrl} alt="Tyre Image" className="w-full cursor-pointer rounded-image" onClick={() => setOpen(true)} />
      <Lightbox open={open} close={() => setOpen(false)} slides={slides} index={currentIndex >= 0 ? currentIndex : 0} plugins={[Fullscreen, Zoom]} />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('tyre-lightbox') as HTMLElement);
root.render(
  <React.StrictMode>
    <TyreLightbox images={tyreImages || [tyreImageUrl]} initialImageUrl={tyreImageUrl} />
  </React.StrictMode>,
);
